const currentlyInSpaMode = () => document.location.pathname.startsWith(process.env.VUE_APP_INTEGRATION_PATH);

export {currentlyInSpaMode};
